import { Commune } from "./commune-interface";
import { FetchOpenData } from "./fetch-open-data";
import { useEffect, useState } from "react";
import GameInputComponent from "./game-module/game-input-component";
import ListComponent from "./game-module/result-list.component";
import MapComponent from "./map-component/map-component";
import { ResetProvider } from "./context/ResetContext";
import { ThemeProvider, CssBaseline, Box, Paper, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, CircularProgress } from "@mui/material";
import theme from "./theme/theme";
import Layout from "./components/layout/Layout";
import ScoreBoardComponent from "./game-module/score-board.component";

function App() {
  const [isLoading, setIsLoading] = useState(false);
  const [communes, setCommunes] = useState<Commune[]>([]);
  const [region] = useState("Martinique");
  const [openAboutDialog, setOpenAboutDialog] = useState(false);
  const [openResetConfirmDialog, setOpenResetConfirmDialog] = useState(false);

  useEffect(() => {
    let active = true;
    FetchOpenData(region, active, setIsLoading, setCommunes);
    return () => {
      active = false;
    };
  }, [region]);

  const confirmReset = () => {
    let newCommunes = [...communes];
    newCommunes.forEach((c) => (c.timeFound = null));
    setCommunes(newCommunes);
    setOpenResetConfirmDialog(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ResetProvider>
        <Layout 
          onReset={() => setOpenResetConfirmDialog(true)}
          onOpenAbout={() => setOpenAboutDialog(true)}
        >
          <Box 
            sx={{ 
              display: 'flex', 
              flexDirection: { xs: 'column', md: 'row' },
              height: { xs: 'auto', md: '100vh' }
            }}
          >
            <Box 
              sx={{ 
                position: 'relative',
                flexGrow: 1,
                height: { xs: 'auto', md: '100%' },
                width: '100%'
              }}
            >
              {communes.length !== 0 ? (
                <>
                  <Box 
                    sx={{ 
                      position: 'absolute',
                      top: { xs: 16, md: 76 },
                      left: '50%',
                      transform: 'translateX(-50%)',
                      zIndex: 10,
                      width: { xs: '90%', sm: 'auto' }
                    }}
                  >
                    <Paper 
                      elevation={3} 
                      sx={{ 
                        p: 2, 
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        borderRadius: 2
                      }}
                    >
                      <GameInputComponent
                        communes={communes}
                        setCommunes={setCommunes}
                      />
                    </Paper>
                  </Box>
                  <MapComponent communes={communes} />
                </>
              ) : (
                <Box 
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    pt: 10
                  }}
                >
                  <CircularProgress size={60} />
                  <Box sx={{ mt: 2 }}>Chargement des communes...</Box>
                </Box>
              )}
            </Box>

            <Box 
              sx={{ 
                width: { xs: '100%', md: '350px' },
                height: { xs: 'auto', md: '100%' },
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                borderLeft: { xs: 'none', md: '1px solid rgba(0, 0, 0, 0.1)' }
              }}
            >
              <Paper 
                elevation={0} 
                sx={{ 
                  p: 2,
                  backgroundColor: theme.palette.primary.main,
                  color: 'white',
                  borderRadius: { xs: 0, md: '0 0 0 8px' }
                }}
              >
                <ScoreBoardComponent communes={communes} />
              </Paper>
              <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
                <ListComponent communes={communes} />
              </Box>
            </Box>
          </Box>

          {/* About Dialog */}
          <Dialog
            open={openAboutDialog}
            onClose={() => setOpenAboutDialog(false)}
          >
            <DialogTitle>A propos</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Site web réalisé par FHocs (frederic@hocansung.com)
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenAboutDialog(false)}>Fermer</Button>
            </DialogActions>
          </Dialog>

          {/* Reset Confirmation Dialog */}
          <Dialog
            open={openResetConfirmDialog}
            onClose={() => setOpenResetConfirmDialog(false)}
          >
            <DialogTitle>Recommencer le jeu</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Vous allez perdre toute votre progression, êtes-vous sûr ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenResetConfirmDialog(false)}>
                Annuler
              </Button>
              <Button 
                variant="contained"
                color="primary"
                onClick={confirmReset}
              >
                Confirmer
              </Button>
            </DialogActions>
          </Dialog>
        </Layout>
      </ResetProvider>
    </ThemeProvider>
  );
}

export default App;
